import invariant from 'fbjs/lib/invariant.js';
import interpolate from '#/lib/interpolate.js';
import { interpolationSelector } from '#/store/slices/interpolation.js';

export function createLinkInterpolation(dependencies) {
  const { store } = dependencies;
  invariant(store, 'Store is required for link interpolation');

  return (creative) => {
    const ctx = interpolationSelector(store.getState());
    invariant(ctx, 'Interpolation context is required for link interpolation');
    for (const widgetKey in creative.widgets) {
      const widget = creative.widgets[widgetKey];
      if (widget.link) {
        const decodedLink = decodeURI(widget.link);
        widget.link = encodeURI(interpolate(decodedLink, ctx));
      }
    }
    return creative;
  };
}
